import { useGetAllTaxesWitCurrentLang } from 'app/modules/taxes/hooks/useTaxes';

import { type OmissionsByTax } from '../types';

import { TaxItem } from './TaxItem';

export const ContainerOmissions = ({ omissions }: { omissions: Array<OmissionsByTax> }) => {
  const { data: taxes, loading, error } = useGetAllTaxesWitCurrentLang();

  if (loading || error) {
    return <></>;
  }

  return (
    <>
      {omissions.map((x) => {
        const name = taxes?.find((y) => y.id === x.taxId)?.name;
        const omission = { ...x, taxName: name } as OmissionsByTax;
        return (
          <>
            <TaxItem omission={omission} />
          </>
        );
      })}
    </>
  );
};
